import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiActions, visualizerActions } from "../../store";
import { generateShareLink } from "../../Helpers/ShareHelper";
import PopUpModal from "../PopUpModal/PopUpModal";
import FormInput from "../FormInput/FormInput";
import FormTextarea from "../FormTextarea/FormTextarea";

import styles from "./SendToSeagateModal.module.css";

import emailIcon from './assets/email.svg';

// Email pop up form
export default function SendToSeagateModal() {

    const dispatch = useDispatch();
    const [formValidity, setFormValidity] = useState({});
    const [buttonText, setButtonText] = useState("Send");

   

    const shareData = useSelector((state) => state.visualizer.shareData);

    const defaultMessage = shareData.message + "\n" + shareData.url;

    const checkFormValidity = function () {
        // for (let key in formValidity) {
        //     if (!formValidity[key]) {
        //         document.getElementById(key).focus();
        //         document.getElementById(key).blur();
        //         return false;
        //     }
        // }

        return true;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
    
        if (checkFormValidity()) {
            setButtonText("Sending...");
            const data = new FormData(event.target);
            const formData = Object.fromEntries(data.entries());
    
            try {
                // Generate share link and add to form data
                const shareData = await generateShareLink();
                dispatch(visualizerActions.setShareData(shareData));
    
                // Add the generated share link to the form data
                formData.shareLink = shareData.url;
                // formData.toEmail = 'customerservice@chameleonpower.com';
                formData.toEmail = 'info@seagatehomes.com';

                console.log(shareData.url)
    
                const response = await fetch('/services/email.ashx', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams(formData),
                });
    
                if (response.ok) {
                    // Handle success
                    setButtonText("Thanks for your submission!");
                    console.log('Form submitted successfully');
                    setTimeout(() => {
                        setButtonText("Send");
                        handleClose();
                    }, 2000); // Reset the button after 2 seconds
                } else {
                    // Handle error
                    setButtonText("Send");
                    console.error('Form submission failed');
                }
            } catch (error) {
                // Handle exceptions
                setButtonText("Send");
                console.error('Error submitting form:', error);
            }
        }
    };
    
    

    const handleClose = () => {
        dispatch(uiActions.setSendToSeagateModalActive(false));
    };

    return (
        <>
            <PopUpModal handleClose={handleClose}>
                <div className={styles.container}>
                    <h1>Send to SeaGate</h1>
                    <p>Please complete the form below with as much detail as you can, and we will get back to you promptly.</p>
                    <form onSubmit={handleSubmit}>
                        <FormInput
                            id="fromName"
                            name="fromName"
                            label="Your Name"
                            type="text"
                            required={true}
                            errorMsg={"Only letters and spaces allowed"}
                            pattern={/^[A-Za-z\s]+$/}
                            setFormValidity={setFormValidity}
                        />
                        <FormInput
                            id="fromEmail"
                            name="fromEmail"
                            label="Your Email"
                            value=""
                            type="email"
                            required={true}
                            errorMsg={"Enter valid email address. ex - someone@example.com"}
                            pattern={/^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/}
                            setFormValidity={setFormValidity}
                        />
                        <FormInput
                            id="shareLink"
                            name="shareLink"
                            type="hidden"
                            errorMsg={""}
                            label=""
                            pattern=""
                            setFormValidity={setFormValidity}
                        />
                        <FormTextarea
                            id="body"
                            name="body"
                            label="Notes"
                            defaultText=""
                            required={true}
                            errorMsg={"Only letters and spaces allowed"}
                            pattern={/.*/}
                            setFormValidity={setFormValidity}
                        />

                        <button type="submit">{buttonText}</button>
                    </form>
                </div>
            </PopUpModal>
        </>
    );
}

// Email share button
const EmailShareLink = () => {
    const dispatch = useDispatch();

    const handleClick = function () {
        dispatch(uiActions.setShareModalActive(false));
        dispatch(uiActions.setEmailModalActive(true));
    }

    return (
        <button className={styles.shareEmailBtn} onClick={handleClick} aria-label="Open Share Modal">
            <img src={emailIcon} className={styles.emailSvg} alt="open share modal icon" />
        </button>
    );
};

export { SendToSeagateModal, EmailShareLink };
